(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nh-recently-viewed')) {
    class NhRecentlyViewed extends HTMLElement {
      async connectedCallback() {
        const key = 'nh_recently_viewed';
        const current = this.dataset.current;
        let list = [];
        try { list = JSON.parse(localStorage.getItem(key)) || []; } catch (e) { list = []; }
        if (current) {
          list = [current, ...list.filter((h) => h !== current)].slice(0, 12);
          try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
        }
        const handles = list.filter((h) => h !== current).slice(0, Number(this.dataset.max));
        if (!handles.length) return;
        const root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
        const products = await Promise.all(
          handles.map((h) => fetch(`${root}products/${h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null))
        );
        const money = (cents) => this.dataset.moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, (cents / 100).toFixed(cents % 100 ? 2 : 0));
        const grid = this.querySelector('.nh-rv__grid');
        products.filter(Boolean).forEach((p) => {
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.className = 'nh-rv__card';
          a.href = `${root}products/${p.handle}`;
          if (p.featured_image) {
            const img = document.createElement('img');
            img.className = 'nh-rv__img';
            img.src = p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=400';
            img.alt = p.title;
            img.loading = 'lazy';
            a.append(img);
          }
          [['nh-rv__vendor', p.vendor], ['nh-rv__title', p.title], ['nh-rv__price', money(p.price)]].forEach(([cls, text]) => {
            const span = document.createElement('span');
            span.className = cls;
            span.textContent = text;
            a.append(span);
          });
          li.append(a);
          grid.append(li);
        });
        if (grid.children.length) this.hidden = false;
      }
    }
    customElements.define('nh-recently-viewed', NhRecentlyViewed);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-wishlist-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nh-wishlist-page')) {
    class NhWishlistPage extends HTMLElement {
      connectedCallback() {
        this.d = this.dataset;
        this.cards = new Map(); // handle -> { li, product, select }
        const params = new URLSearchParams(window.location.search);
        const shared = (params.get('liste') || '').split(',').map((h) => h.trim()).filter(Boolean).slice(0, 60);
        this.shared = shared.length ? shared : null;
        this.querySelectorAll('[data-shared]').forEach((el) => (el.hidden = !this.shared));
        this.querySelectorAll('[data-mine]').forEach((el) => (el.hidden = !!this.shared));
        this.querySelectorAll('[data-action]').forEach((b) => b.addEventListener('click', () => this.action(b.dataset.action, b)));
        this.onChange = (e) => this.changed(e.detail);
        document.addEventListener('nh:wishlist-changed', this.onChange);
        this.whenReady(() => this.load());
      }
      disconnectedCallback() {
        document.removeEventListener('nh:wishlist-changed', this.onChange);
      }
      whenReady(fn) {
        if (window.NhWishlist) return fn();
        let tries = 0;
        const t = setInterval(() => {
          if (window.NhWishlist || ++tries > 50) {
            clearInterval(t);
            fn();
          }
        }, 100);
      }
      handles() {
        if (this.shared) return this.shared;
        return window.NhWishlist ? window.NhWishlist.list() : [];
      }

      /* ---------- loading ---------- */
      async load() {
        const handles = this.handles();
        const grid = this.querySelector('[data-grid]');
        grid.textContent = '';
        this.cards.clear();
        if (!handles.length) return this.refresh();
        this.querySelector('[data-loading]').hidden = false;
        const products = await Promise.all(
          handles.map((h) =>
            fetch(`${this.d.root}products/${encodeURIComponent(h)}.js`)
              .then((r) => (r.ok ? r.json() : null))
              .catch(() => undefined)
          )
        );
        this.querySelector('[data-loading]').hidden = true;
        // Products that no longer exist (404) leave the visitor's own list.
        if (!this.shared && window.NhWishlist) {
          const gone = handles.filter((h, i) => products[i] === null);
          if (gone.length) window.NhWishlist.set(window.NhWishlist.list().filter((h) => !gone.includes(h)));
        }
        products.forEach((p, i) => {
          if (!p) return;
          const card = this.card(p, handles[i]);
          this.cards.set(handles[i], card);
          grid.append(card.li);
        });
        this.refresh();
      }

      money(cents) {
        const format = this.d.moneyFormat || '{' + '{amount}}';
        const kind = (format.match(/\{\{\s*(\w+)\s*\}\}/) || [null, 'amount'])[1];
        const comma = kind.indexOf('comma') >= 0;
        const decimals = kind.indexOf('no_decimals') < 0 && cents % 100 !== 0;
        let [int, dec] = (cents / 100).toFixed(decimals ? 2 : 0).split('.');
        int = int.replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : kind.indexOf('space') >= 0 ? ' ' : ',');
        return format.replace(/\{\{\s*\w+\s*\}\}/, dec ? int + (comma ? ',' : '.') + dec : int);
      }
      saving(v) {
        if (!v.compare_at_price || v.compare_at_price <= v.price || this.d.savingMode === 'label') return '';
        const diff = v.compare_at_price - v.price;
        if (this.d.savingMode === 'percent') return `-${Math.round((diff * 100) / v.compare_at_price)} %`;
        return `-${this.money(diff)}`;
      }

      el(tag, cls, text) {
        const e = document.createElement(tag);
        if (cls) e.className = cls;
        if (text != null) e.textContent = text;
        return e;
      }

      card(p, handle) {
        const li = this.el('li', 'nh-wl__item');
        const url = `${this.d.root}products/${p.handle}`;
        const media = this.el('a', 'nh-wl__media');
        media.href = url;
        media.tabIndex = -1;
        media.setAttribute('aria-hidden', 'true');
        if (p.featured_image) {
          const img = this.el('img');
          const src = p.featured_image.startsWith('//') ? `https:${p.featured_image}` : p.featured_image;
          img.src = src + (src.includes('?') ? '&' : '?') + 'width=600';
          img.alt = '';
          img.loading = 'lazy';
          img.width = 600;
          img.height = 600;
          media.append(img);
        }
        const badge = this.el('span', 'nh-wl__badge');
        media.append(badge);

        // Heart: same markup as snippets/nh-wishlist-heart.liquid (handled by nh-wishlist.js).
        const heart = this.el('button', 'nh-wish nh-wish--card');
        heart.type = 'button';
        heart.dataset.nhWish = handle;
        heart.dataset.nhWishTitle = p.title;
        heart.dataset.labelAdd = this.d.labelAdd;
        heart.dataset.labelRemove = this.d.labelRemove;
        heart.setAttribute('aria-pressed', window.NhWishlist && window.NhWishlist.has(handle) ? 'true' : 'false');
        heart.setAttribute('aria-label', `${heart.getAttribute('aria-pressed') === 'true' ? this.d.labelRemove : this.d.labelAdd} : ${p.title}`);
        heart.innerHTML =
          '<svg class="nh-wish__icon" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M12 20.3s-7.6-4.6-9.2-9.4C1.7 7.6 3.8 4.4 7.1 4.4c2 0 3.6 1.1 4.9 2.9 1.3-1.8 2.9-2.9 4.9-2.9 3.3 0 5.4 3.2 4.3 6.5-1.6 4.8-9.2 9.4-9.2 9.4Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';

        const wrap = this.el('div');
        wrap.style.position = 'relative';
        wrap.append(media, heart);
        li.append(wrap);

        if (p.vendor) li.append(this.el('span', 'nh-wl__vendor', p.vendor));
        const name = this.el('a', 'nh-wl__name', p.title);
        name.href = url;
        li.append(name);
        const price = this.el('div', 'nh-wl__price');
        li.append(price);

        let select = null;
        const real = p.variants.filter((v) => !(p.variants.length === 1 && v.title === 'Default Title'));
        if (real.length > 1) {
          select = this.el('select', 'nh-wl__select');
          select.setAttribute('aria-label', p.options && p.options[0] ? p.options[0].name || p.options[0] : p.title);
          p.variants.forEach((v) => {
            const o = this.el('option', null, v.available ? v.title : `${v.title} — ${this.d.soldOut}`);
            o.value = v.id;
            o.disabled = !v.available;
            select.append(o);
          });
          const first = p.variants.find((v) => v.available) || p.variants[0];
          select.value = String(first.id);
          li.append(select);
        }
        const add = this.el('button', 'nh-wl__btn nh-wl__btn--primary nh-wl__add');
        add.type = 'button';
        li.append(add);

        const card = { li, product: p, select, add, price, badge };
        if (select) select.addEventListener('change', () => this.paintCard(card));
        add.addEventListener('click', () => this.addToCart([card], add));
        this.paintCard(card);
        return card;
      }
      variantOf(card) {
        const p = card.product;
        if (card.select) return p.variants.find((v) => String(v.id) === card.select.value) || p.variants[0];
        return p.variants.find((v) => v.available) || p.variants[0];
      }
      paintCard(card) {
        const v = this.variantOf(card);
        const available = !!(v && v.available);
        card.li.classList.toggle('is-sold-out', !available);
        card.price.textContent = '';
        const now = this.el('span', null, this.money(v.price));
        card.price.append(now);
        if (v.compare_at_price > v.price) {
          card.price.classList.add('nh-wl__price--sale');
          card.price.append(this.el('s', null, this.money(v.compare_at_price)));
        } else card.price.classList.remove('nh-wl__price--sale');
        const save = available ? this.saving(v) : '';
        card.badge.hidden = !(save || !available);
        card.badge.className = `nh-wl__badge ${available ? 'nh-wl__badge--sale' : 'nh-wl__badge--out'}`;
        card.badge.textContent = available ? save : this.d.soldOut;
        card.add.disabled = !available;
        card.add.textContent = available ? this.d.add : this.d.soldOut;
      }

      /* ---------- state ---------- */
      changed(detail) {
        if (this.shared) return; // a shared list doesn't change with the visitor's own hearts
        const list = detail.list || [];
        for (const [handle, card] of this.cards) {
          if (list.includes(handle)) continue;
          this.cards.delete(handle);
          card.li.classList.add('is-leaving');
          setTimeout(() => card.li.remove(), 250);
        }
        // Added from another tab: reload to show it.
        if (list.some((h) => !this.cards.has(h))) return this.load();
        this.refresh();
      }
      refresh() {
        const n = this.cards.size;
        this.querySelector('[data-empty]').hidden = n > 0;
        this.querySelector('[data-bar]').hidden = n === 0;
        const tpl = n === 1 ? this.d.countOne : this.d.countMany;
        this.querySelector('[data-count]').textContent = (tpl || '[count]').replace('[count]', n);
        const anyAvailable = [...this.cards.values()].some((c) => this.variantOf(c).available);
        this.querySelectorAll('[data-action="cart-all"], [data-action="whatsapp"]').forEach((b) => (b.disabled = !anyAvailable));
      }
      note(text) {
        const el = this.querySelector('[data-note]');
        el.textContent = text || '';
        el.hidden = !text;
      }

      /* ---------- actions ---------- */
      action(name, button) {
        if (name === 'cart-all') return this.addToCart([...this.cards.values()], button);
        if (name === 'whatsapp') return this.whatsapp();
        if (name === 'share') return this.share();
        if (name === 'save-all' && window.NhWishlist) {
          const found = [...this.cards.keys()];
          window.NhWishlist.set([...found, ...window.NhWishlist.list()]);
          window.NhWishlist.track('save_shared', { count_shared: found.length });
          button.disabled = true;
          this.note(this.d.added);
        }
      }

      async addToCart(cards, button) {
        const items = cards
          .map((c) => this.variantOf(c))
          .filter((v) => v && v.available)
          .map((v) => ({ id: v.id, quantity: 1 }));
        if (!items.length) return;
        const label = button.textContent;
        button.disabled = true;
        button.textContent = this.d.adding;
        this.note('');
        let ok = false;
        let status = 0;
        try {
          // window.fetch is wrapped by nh-cart.js: the gift bar and cart bubble update by themselves.
          const res = await fetch(`${this.d.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          status = res.status;
          ok = res.ok;
        } catch (e) {}
        if (ok) {
          if (window.NhWishlist) window.NhWishlist.track('cart', { count_cart: items.length });
          button.textContent = this.d.added;
          try {
            if (window.nhRefreshCart) await window.nhRefreshCart();
            if (window.nhRenderDrawer) await window.nhRenderDrawer();
          } catch (e) {}
          const drawer = document.querySelector('theme-drawer#cart-drawer');
          if (drawer && drawer.open) drawer.open();
          else window.location.href = `${this.d.root}cart`;
          setTimeout(() => {
            button.textContent = label;
            button.disabled = false;
          }, 1500);
          return;
        }
        button.textContent = label;
        button.disabled = false;
        if (status === 422) this.note(this.d.refused);
      }

      whatsapp() {
        const lines = [];
        let total = 0;
        for (const c of this.cards.values()) {
          const v = this.variantOf(c);
          const option = c.select ? ` (${v.title})` : '';
          if (v.available) {
            total += v.price;
            lines.push(`• ${c.product.title}${option} : ${this.money(v.price)}`);
          } else if (this.d.unavailable) {
            lines.push(`• ${c.product.title}${option} : ${this.d.unavailable}`);
          }
        }
        const tpl = this.d.waMessage || '[list]\n[total]';
        const text = tpl
          .replace('[list]', lines.join('\n'))
          .replace('[total]', this.money(total))
          .replace('[count]', String(this.cards.size));
        if (window.NhWishlist) window.NhWishlist.track('whatsapp', { count_cart: lines.length, total: Math.round(total / 100) });
        window.open(`https://wa.me/${this.d.waNumber}?text=${encodeURIComponent(text)}`, '_blank', 'noopener');
      }

      async share() {
        const handles = [...this.cards.keys()];
        const url = `${window.location.origin}${window.location.pathname}?liste=${handles.map(encodeURIComponent).join(',')}`;
        const text = this.d.shareText || '';
        if (window.NhWishlist) window.NhWishlist.track('share', { count_shared: handles.length });
        if (navigator.share) {
          try {
            await navigator.share({ title: document.title, text, url });
            return;
          } catch (e) {
            if (e && e.name === 'AbortError') return;
          }
        }
        window.open(`https://wa.me/?text=${encodeURIComponent(text ? `${text}\n${url}` : url)}`, '_blank', 'noopener');
      }
    }
    customElements.define('nh-wishlist-page', NhWishlistPage);
  }

  } catch(e) { console.error(e); }
})();
})();
